// extracted by mini-css-extract-plugin
module.exports = {"tertiary-icon":"tertiary-icon__1g4RQ","icon":"icon__23nGc"};